export const QUICK_FIND_PLACEMENT_ID = 'search-page-results-quick-find';
